import { createSlice } from "@reduxjs/toolkit";
import { CreateCampaign } from "../Apis/CreateCampaign";

export const CreateCampaignSlice = createSlice({
  name: "createcampaign",
  initialState: {
    createcampaign: null,
    authenticatingcreatecampaign: false,
    authenticated: false,
    isError: false,
    errors: null
  },
  reducers: {
    clearState: (state) => {
      state.createcampaign = null;
      state.isError = false;
      state.authenticated = false;
      state.authenticatingcreatecampaign = false;
      return state;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(CreateCampaign.fulfilled, (state, action) => {
      state.createcampaign = action.payload;
      state.authenticated = false;
      state.authenticatingcreatecampaign = false;
      return state;
    });
    builder.addCase(CreateCampaign.pending, (state, action) => {
      state.authenticatingcreatecampaign = true;
      state.authenticated = true;
    });
    builder.addCase(CreateCampaign.rejected, (state, action) => {
      state.errors = action.errors || action.payload;
      state.authenticated = false;
      state.authenticatingcreatecampaign = false;
      state.isError = true;
      return state;
    });
  }
});

export const { clearState } = CreateCampaignSlice.actions;

export const CreateCampaignSelector = (state) => state.createcampaign;
